var _style, _polygon, _g, _path, _g2, _polygon2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVerkeiersVerbond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210 100.9",
    style: {
      enableBackground: "new 0 0 210 100.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#83276B;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "94,75.7 91.1,75.7 84,59 87.1,59 92.5,73.4 97.9,59 101,59 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.6,76c-0.7,0-5-0.3-5-6v-5.3c0-3,1.7-5.7,5.7-5.7h2.3c4.2,0,5.3,2.6,5.3,4.7V67c0,1.1-0.6,1.7-1.4,1.7 h-9.4v2.2c0,1.3,1.2,2.7,2.8,2.7c3.2,0,7.1-0.6,8.2-1v2.2C116.3,74.8,113,76,107.6,76 M113.7,63.7c0-1.4-0.8-2.5-2.5-2.5h-3.5 c-1.7,0-2.5,1-2.5,2.5v2.9h8.4v-2.9H113.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.8,61.3c-1,0-2.9,0.5-3.5,0.6v13.7h-2.6V59h1.9l0.5,1.2c0.9-0.6,3.3-1.6,4.3-1.6v2.7L125.8,61.3 L125.8,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139,69l5,6.6h-3.2l-4.7-6.6h-3.8v6.6h-2.6V54.3h2.6V60c1.7-0.6,5-1.4,7.1-1.4c2,0,5,1,5,5.3 C144.3,67.6,141.1,69,139,69 M138.8,61c-1,0-5.1,0.8-6.6,1v5h5.9c2.5,0,3.7-0.9,3.7-3.2C141.8,62.1,140.9,61,138.8,61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.4,76c-0.7,0-5-0.3-5-6v-5.3c0-3,1.7-5.7,5.7-5.7h2.3c4.2,0,5.3,2.6,5.3,4.7V67c0,1.1-0.6,1.7-1.4,1.7 h-9.4v2.2c0,1.3,1.2,2.7,2.8,2.7c3.2,0,7.1-0.6,8.2-1v2.2C161,74.8,157.7,76,152.4,76 M158.4,63.7c0-1.4-0.8-2.5-2.5-2.5h-3.5 c-1.7,0-2.5,1-2.5,2.5v2.9h8.4v-2.9H158.4z M154.5,56.8l-1.5-1.5l3.2-3.5l2,2L154.5,56.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.4,54h3v3h-3V54z M164.6,59h2.5v16.7h-2.5V59z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.1,76c-0.7,0-5-0.3-5-6v-5.3c0-3,1.7-5.7,5.7-5.7h2.3c4.2,0,5.3,2.6,5.3,4.7V67c0,1.1-0.6,1.7-1.4,1.7 h-9.4v2.2c0,1.3,1.2,2.7,2.8,2.7c3.2,0,7.1-0.6,8.2-1v2.2C184.7,74.8,181.4,76,176.1,76 M182.1,63.7c0-1.4-0.8-2.5-2.5-2.5h-3.5 c-1.7,0-2.5,1-2.5,2.5v2.9h8.4v-2.9H182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.5,61.3c-1,0-2.9,0.5-3.5,0.6v13.7h-2.6V59h1.9l0.5,1.2c0.9-0.6,3.3-1.6,4.3-1.6v2.7L194.5,61.3 L194.5,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205,76c-5,0-7.6-0.7-7.6-0.7V73c0,0,4,0.7,7.9,0.7c1.7,0,2.2-1,2.2-2v-3.2h-7c-1.9,0-2.8-0.9-2.8-2.5v-3 c0-2.7,2-4,5-4h6v2.3h-7.2c-0.9,0-1.3,0.7-1.3,1.4v3.5h7.5c2.1,0,2.3,1.9,2.3,2.3V71C210,76,205.6,76,205,76"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "97.9,83.8 92.5,98.2 87.1,83.8 84,83.8 91.1,100.5 94,100.5 101,83.8 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.6,100.8c-0.7,0-5-0.3-5-6v-5.3c0-3,1.7-5.7,5.7-5.7h2.3c4.2,0,5.3,2.6,5.3,4.7v3.3c0,1.1-0.6,1.7-1.4,1.7 h-9.4v2.2c0,1.3,1.2,2.7,2.8,2.7c3.2,0,7.1-0.6,8.2-1v2.2C116.3,99.6,113,100.8,107.6,100.8 M113.6,88.5c0-1.4-0.8-2.5-2.5-2.5 h-3.5c-1.7,0-2.5,1-2.5,2.5v2.9h8.4v-2.9H113.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.7,86.1c-1,0-2.9,0.4-3.5,0.6v13.7h-2.6V83.7h1.9l0.5,1.2c0.9-0.6,3.3-1.6,4.3-1.6V86L125.7,86.1 L125.7,86.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.1,100.5h-7.8c-1.6,0-1.7-1.7-1.7-1.7V79.7h2.6V85c0.8-0.3,4.8-1.6,7.5-1.6c1.1,0,4.9,0.3,4.9,6v5.3 C144.7,98.1,142.7,100.5,139.1,100.5 M142.1,88.6c0-2.1-1.4-2.8-2.7-2.8c-2.1,0-7.2,1-7.2,1V98h7.3c1.8,0,2.5-0.8,2.5-2.5v-6.9 H142.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.1,100.5h-5.3c-4.3,0-4.3-4.3-4.3-4.3v-6.6c0,0,0-5.7,5.6-5.7h5.3c4,0,4.3,4.3,4.3,4.3v6.6 C162.8,94.8,162.8,100.5,157.1,100.5 M160.3,88.5c0-1.3-0.7-2.4-2.5-2.4h-5.4c-1.7,0-2.5,1-2.5,2.5v7c0,1.3,0.9,2.4,2.5,2.4h5.3 c2.1,0,2.5-1.1,2.5-2.5v-7H160.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.7,100.5V89.4c0-1.4-0.2-3.4-2.8-3.4c-1.9,0-7,1.1-7,1.1v13.5h-2.6V83.9h1.9l0.5,1.2c0,0,4.5-1.6,7.7-1.6 c2,0,4.9,0.4,4.9,6v11H178.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.7,100.5l-0.5-1c-0.8,0.3-4.3,1.4-7.6,1.4c-1.1,0-4.9-0.3-4.9-6v-5.3c0-3.3,2-5.7,5.5-5.7h6.9v-4.1h2.6 v20.8L197.7,100.5L197.7,100.5z M197.2,86.1h-7.3c-1.8,0-2.5,0.8-2.5,2.5v7c0,2.1,1.4,2.8,2.7,2.8c2.4,0,7.2-0.9,7.2-0.9V86.1 H197.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.5,86.5l-20.9,6.4c0,0-9.3,2.8-15.9-1.8C1.1,87.1,0,83.5,0,76.5V9.1c0-2.7,1.7-4.8,3.8-4.7l54.7,3.9l1.9-7 c0,0,0.4-1.3,1.5-1.3l5.6,0.3L46.8,67.1c0,0-0.7,3.1-3.2,3.3c-2.1,0.2-3.5-3.4-3.5-3.4L18.5,23.9c-0.5-0.8,0.3-0.7,0.3-0.7h8.5 c0.3,0,0.5,0.3,0.5,0.3l16.3,33.7l12.1-41.6L9.9,14.1v0.3v60.2c0,5.7,2.1,8.6,5.6,9.7c3.2,1,5.9,0.3,5.9,0.3S62.1,74.1,68.8,72 V34.2V9.7l5.3,0.4c0.4,0,0.4,0.3,0.4,0.3v3.1c0,0,0,18.9,0,19v41.9v1.1c0,0.2-0.2,0.4-0.4,0.5C74,76,64,80.3,43.5,86.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVerkeiersVerbond);
export default __webpack_public_path__ + "static/media/logo_verkeiers_verbond.02803bde9b1822d31c97ee818a1870df.svg";
export { ForwardRef as ReactComponent };